import { Ear, ScanSearch, Compass } from "lucide-react";
import Reveal, { SectionLabel } from "./Reveal";

const BLOCKS = [
  {
    n: "01",
    icon: Ear,
    title: "Escuta",
    text: "Tempo pra você contar sua história completa.",
  },
  {
    n: "02",
    icon: ScanSearch,
    title: "Investigação",
    text: "Avaliação do quadro inteiro, não só da queixa.",
  },
  {
    n: "03",
    icon: Compass,
    title: "Clareza",
    text: "Você sai da consulta entendendo o que está acontecendo e qual é o plano.",
  },
];

export default function Diferencial() {
  return (
    <section id="diferencial" className="bg-cream py-28 md:py-36">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="03">Diferencial</SectionLabel>

        <div className="mt-8 grid gap-10 lg:grid-cols-[1fr_0.9fr] lg:items-end">
          <Reveal delay={0.08}>
            <h2 className="font-display font-medium text-[clamp(2.1rem,4.6vw,4rem)] leading-[1.06] tracking-[-0.01em]">
              Um olhar que vai <em className="font-serifd italic text-terra">além</em> da queixa
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <blockquote className="border-l-2 border-sun pl-6 font-serifd italic text-lg md:text-xl leading-relaxed text-olive/85">
              “O sistema nervoso conversa com o sono, a alimentação, o intestino, as emoções e a
              rotina. Na consulta, eu olho para esse conjunto pra entender o que está por trás do
              sintoma, e não só aliviá-lo.”
            </blockquote>
          </Reveal>
        </div>

        <div className="mt-14 md:mt-20 grid gap-5 md:grid-cols-3" data-testid="diferencial-blocks">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.n} delay={0.08 * i} className="h-full">
              <article className="group relative h-full rounded-[24px] bg-olive p-8 md:p-10 text-cream transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-olive/30">
                <span className="absolute right-8 top-7 font-display italic text-5xl text-cream/15 transition-colors duration-500 group-hover:text-sun/40">
                  {b.n}
                </span>
                <span className="inline-flex size-14 items-center justify-center rounded-full bg-terra text-cream transition-transform duration-500 group-hover:rotate-6 group-hover:scale-110">
                  <b.icon className="size-6" />
                </span>
                <h3 className="mt-7 font-display text-2xl md:text-3xl font-medium">{b.title}</h3>
                <p className="mt-3 text-base md:text-lg leading-relaxed text-cream/75">{b.text}</p>
                <span className="mt-7 block h-[3px] w-12 rounded-full bg-sun transition-all duration-500 group-hover:w-24" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
